import type { PopupData } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

import type BillingPlan from 'webapp/models-custom/billing-plan';

export default class BillingPopupTrialActivatedComponent extends PopupInnerModalComponent<PopupData.Billing.TrialActivated> {
	get model(): BillingPlan {
		return this.popupData.model;
	}
	<template>
		<div class="content">
			<CommonUiIconComponent @name="CheckCircleFill" @size="2xl" />
			<h3>Your trial of {{this.model.name}} has been activated.</h3>
			<p>
				You can access additional features now. If you'd like help getting set up during
				your trial, please email
				<a class="email" href="mailto:help@databox.com">help@databox.com</a>.
			</p>
			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent @text="Close" @onTrigger={{this.close}} />
				</div>
			</div>
		</div>
	</template>
}
